module.exports = __webpack_public_path__ + "img/HIDE.6362d093.svg";